import { trpc } from '@utils/trpc';
import type { Control, FieldValues, Path } from 'react-hook-form';
import { ControlledBetterSelectInput } from '../BetterSelectInput';

export const useReferralSourceOptions = () => trpc.referralSources.list.useQuery();

interface ReferralSourceSelectProps<TFieldValues extends FieldValues> {
	control: Control<TFieldValues>;
	id: string;
	isFullWidth?: boolean;
	labelText?: string;
	name: Path<TFieldValues>;
	testId?: string;
}

export const ReferralSourceSelect = <TFieldValues extends FieldValues>({
	control,
	id,
	isFullWidth,
	labelText = 'Referral Source',
	name,
	testId,
}: ReferralSourceSelectProps<TFieldValues>) => {
	const { data: options, isLoading } = useReferralSourceOptions();

	return (
		<ControlledBetterSelectInput
			canBeNull
			control={control}
			id={id}
			isFullWidth={isFullWidth}
			isLoading={isLoading}
			labelText={labelText}
			name={name}
			options={(options ?? []).map((option) => ({ label: option.name, value: option.id }))}
			placeholder="Select a source"
			testId={testId}
		/>
	);
};
